export default "/_next/static/chunks/fonts/HK Grotesk Semi Bold Italic-93553acb0f1fcb3a3fbf99a7a0f70f27.otf";